function assertPrintFileUri(value) {
  if (typeof value !== "string" || value.length === 0) {
    throw new Error("Print.printPdf: fileUri must be a non-empty string");
  }
}
function assertPrintJobName(value) {
  if (value !== void 0 && (typeof value !== "string" || value.length === 0)) {
    throw new Error("Print.printPdf: jobName must be a non-empty string when provided");
  }
}
export {
  assertPrintFileUri,
  assertPrintJobName
};
//# sourceMappingURL=validate.js.map
